module.exports = __webpack_public_path__ + "static/media/need-travel-coverage.24711b81.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/need/need-travel-coverage.jpg
// module id = 363
// module chunks = 0